/* velara-video v2 - Mon Jul  6 03:22:35 UTC 2026 */
(function() {
  function initVelaraVideo() {
    var video = document.querySelector('video[src*="667806e262d4466cb1dc4de2d8fcbf52"]');
    var btn = document.querySelector('.velara-play-btn');
    video.controls = true;
    if (btn) {
      btn.addEventListener('click', function() {
        if (video.paused) { video.play(); btn.classList.add('hidden'); }
        else { video.pause(); btn.classList.remove('hidden'); }
      });
    }
    video.addEventListener('play', function() { if (btn) btn.classList.add('hidden'); });
    video.addEventListener('pause', function() { if (btn) btn.classList.remove('hidden'); });
    video.addEventListener('ended', function() { if (btn) btn.classList.remove('hidden'); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVelaraVideo);
  } else {
    initVelaraVideo();
  }
})();
/* ts:1783308155 */